import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { GetRewardHistoryStoreList, SetRewardHistoryStoreList } from "../../store/rewardHistoryAtom";
import { rewardService } from "../../services/Reward.service";

function RewardScroller(props) {
  const getRecoilList = GetRewardHistoryStoreList();
  const [tableData, setTableData] = useState([]);
    const setRecoilList = SetRewardHistoryStoreList();
  
  const { corporate_id } = useParams();



  useEffect(()=> {
    
    if(getRecoilList.reward_info.length){
      setTableData(getRecoilList.reward_info);
       
    }else{
        getRewardList();
    }
//   eslint-disable-next-line react-hooks/exhaustive-deps
  },[getRecoilList]);


   
    function getRewardList(){
      rewardService.getRewardHistory().then( response => {
        if(response?.data?.reward_info?.length){
          setRecoilList(response?.data);
          setTableData(response?.data?.reward_info);
       
        }
    });
  
    }



  const manageStatus = (statusCode, statusName) => {
    let defaultClass = "bg-blue-500 text-white";
    switch (statusCode) {
      case 1:
        defaultClass = "bg-green-500 text-white";
        break;
      case 2:
        defaultClass = "bg-yellow-500 text-white";
        break;
      case 3:
        defaultClass = "bg-red-500 text-white";
        break;
      case 4:
        defaultClass = "bg-purple-500 text-white";
        break;
      case 5:
        defaultClass = "bg-indigo-500 text-white";
        break;
      case 6:
        defaultClass = "bg-gray-500 text-white";
        break;
      default:
        break;
    }
    return (
      <span className={`py-1 px-3 rounded-full text-sm font-medium ${defaultClass}`}>
        {statusName}
      </span>
    );
  };

  return (
    <div className="space-y-2 max-h-96 overflow-y-auto p-2">
    {tableData?.map((reward, index) => (
      <div
        key={index}
        onClick={() => props.viewItemDetails(reward?.Ref_No)}
        className={`flex items-center p-3 border rounded-lg hover:bg-gray-100 cursor-pointer ${
          Number(corporate_id) === reward?.Corporate_Id ? "bg-blue-50 border-blue-500" : ""
        }`}
      >
        <div className="flex items-center w-8"></div>
        <div className="flex-1">
          <div className="font-bold text-sm text-gray-800">{reward?.Corporate_Name}</div>
          <div className="text-sm italic text-gray-600">{reward?.Customer_Email_Address}</div>
          <div className="text-sm text-gray-600">{reward?.Customer_Full_Name}</div>
          <div className="text-sm text-blue-500 font-bold">
            {reward?.Reward_Cowries_Quantity} Cowrie(s)
          </div>
        </div>
      </div>
    ))}
  </div>
  
  );
}

export default RewardScroller;